import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class StockistsList {
    constructor(container) {
        this.container = container;
        this.items = container.querySelectorAll('.stockists-list__item');

        this.init();
    }

    init = () => {
        if (!this.items.length) return;

        // The list runs to ~80 rows, so reveal them as they scroll in rather
        // than staggering the whole section off one trigger.
        gsap.set(this.items, { opacity: 0, y: 40 });
        ScrollTrigger.batch(this.items, {
            interval: 0.1,
            start: 'top 92%',
            once: true,
            onEnter: (batch) => {
                gsap.to(batch, {
                    opacity: 1,
                    y: 0,
                    duration: 0.7,
                    ease: 'power2.out',
                    stagger: { each: 0.05 },
                    overwrite: 'auto',
                });
            },
        });
    };
}
